import React, { useState } from 'react';
import { 
  Target,
  DollarSign,
  CreditCard,
  Calculator,
  TrendingUp,
  TrendingDown,
  PieChart,
  BarChart3,
  FileText,
  Eye,
  Trash2,
  Edit,
  Save,
  X,
  Plus,
  Search,
  Filter,
  MoreHorizontal,
  Bookmark,
  Star,
  Share,
  Info,
  ExternalLink,
  Archive,
  Send,
  Flag,
  Heart,
  ThumbsUp,
  ThumbsDown,
  Upload,
  FileUp,
  FileDown,
  FileCheck,
  FileX,
  Volume2,
  VolumeX,
  Headphones,
  Speaker,
  Radio,
  Music,
  Video,
  Camera,
  Image,
  File,
  Folder,
  FolderOpen,
  HardDrive,
  Cloud,
  Wifi,
  WifiOff,
  Signal,
  Battery,
  BatteryLow,
  Power,
  PowerOff,
  Activity,
  Zap,
  Shield,
  Lock,
  Key,
  Users,
  Building,
  Calendar,
  Phone,
  Mail,
  MapPin,
  CheckSquare,
  Square as SquareIcon,
  ArrowUpRight,
  ArrowDownRight,
  ArrowLeft,
  Home,
  Wrench,
  FileBarChart,
  Cog,
  Settings,
  Link,
  Monitor,
  Tablet,
  Smartphone,
  Lightbulb,
  Cpu,
  Network,
  Database,
  Layers,
  User,
  Languages,
  Mic,
  Play,
  Pause,
  Square,
  RefreshCw,
  Copy,
  Download,
  Globe,
  Users2,
  AlertTriangle,
  CheckCircle,
  XCircle,
  Clock,
  Brain,
  MessageSquare,
  AlertCircle,
  CheckSquare as CheckSquareIcon,
  Receipt,
  Bot,
  Scan,
  Zap as ZapIcon,
  Shield as ShieldIcon,
  LineChart,
  BarChart,
  PieChart as PieChartIcon,
  AreaChart,
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  ArrowUp,
  ArrowDown,
  Minus,
  Percent,
  Calendar as CalendarIcon,
  Clock as ClockIcon,
  AlertCircle as AlertCircleIcon,
  Info as InfoIcon,
  Lightbulb as LightbulbIcon,
  Award,
  Gift,
  Coins,
  Wallet,
  PiggyBank,
  Banknote,
  Receipt as ReceiptIcon,
  ShoppingCart,
  Package,
  Truck,
  Building2,
  Factory,
  Store,
  Home as HomeIcon,
  Car,
  Plane,
  Train,
  Ship,
  Fuel,
  Wrench as WrenchIcon,
  Tool,
  Hammer,
  Screwdriver,
  Cog as CogIcon,
  Settings as SettingsIcon,
  BarChart as BarChartIcon,
  PieChart as PieChartIcon2,
  Activity as ActivityIcon,
  Zap as ZapIcon2,
  Target as TargetIcon,
  Brain as BrainIcon,
  Database as DatabaseIcon,
  Layers as LayersIcon,
  Network as NetworkIcon,
  Cpu as CpuIcon,
  Monitor as MonitorIcon,
  Smartphone as SmartphoneIcon,
  Tablet as TabletIcon,
  Globe as GlobeIcon,
  Users as UsersIcon,
  Building as BuildingIcon,
  Home as HomeIcon2,
  Car as CarIcon,
  Plane as PlaneIcon,
  Train as TrainIcon,
  Ship as ShipIcon,
  Truck as TruckIcon,
  Package as PackageIcon,
  ShoppingCart as ShoppingCartIcon,
  Receipt as ReceiptIcon2,
  Banknote as BanknoteIcon,
  PiggyBank as PiggyBankIcon,
  Wallet as WalletIcon,
  Coins as CoinsIcon,
  Gift as GiftIcon,
  Award as AwardIcon,
  Lightbulb as LightbulbIcon2,
  Info as InfoIcon2,
  AlertCircle as AlertCircleIcon2,
  Clock as ClockIcon2,
  Calendar as CalendarIcon2,
  Percent as PercentIcon,
  Minus as MinusIcon,
  ArrowDown as ArrowDownIcon,
  ArrowUp as ArrowUpIcon,
  TrendingDown as TrendingDownIcon2,
  TrendingUp as TrendingUpIcon2,
  AreaChart as AreaChartIcon,
  Shield as ShieldIcon2,
  Scan as ScanIcon,
  Bot as BotIcon,
  CheckSquare as CheckSquareIcon2,
  MessageSquare as MessageSquareIcon2,
  Brain as BrainIcon2,
  Target as TargetIcon2,
  Zap as ZapIcon3,
  Activity as ActivityIcon2,
  BarChart as BarChartIcon2,
  PieChart as PieChartIcon3,
  LineChart as LineChartIcon,
  TrendingDown as TrendingDownIcon3,
  TrendingUp as TrendingUpIcon3,
  Calculator as CalculatorIcon,
  CreditCard as CreditCardIcon,
  DollarSign as DollarSignIcon,
  FileText as FileTextIcon,
  Eye as EyeIcon,
  Trash2 as Trash2Icon,
  Edit as EditIcon,
  Save as SaveIcon,
  X as XIcon,
  Plus as PlusIcon,
  Search as SearchIcon,
  Filter as FilterIcon,
  MoreHorizontal as MoreHorizontalIcon,
  Bookmark as BookmarkIcon,
  Star as StarIcon,
  Share as ShareIcon,
  Info as InfoIcon3,
  ExternalLink as ExternalLinkIcon,
  Archive as ArchiveIcon,
  Send as SendIcon,
  Flag as FlagIcon,
  Heart as HeartIcon,
  ThumbsUp as ThumbsUpIcon,
  ThumbsDown as ThumbsDownIcon,
  Upload as UploadIcon,
  FileUp as FileUpIcon,
  FileDown as FileDownIcon,
  FileCheck as FileCheckIcon,
  FileX as FileXIcon,
  Volume2 as Volume2Icon,
  VolumeX as VolumeXIcon,
  Headphones as HeadphonesIcon,
  Speaker as SpeakerIcon,
  Radio as RadioIcon,
  Music as MusicIcon,
  Video as VideoIcon,
  Camera as CameraIcon,
  Image as ImageIcon,
  File as FileIcon,
  Folder as FolderIcon,
  FolderOpen as FolderOpenIcon,
  HardDrive as HardDriveIcon,
  Cloud as CloudIcon,
  Wifi as WifiIcon,
  WifiOff as WifiOffIcon,
  Signal as SignalIcon,
  Battery as BatteryIcon,
  BatteryLow as BatteryLowIcon,
  Power as PowerIcon,
  PowerOff as PowerOffIcon,
  Activity as ActivityIcon3,
  Zap as ZapIcon4,
  Shield as ShieldIcon3,
  Lock as LockIcon,
  Key as KeyIcon,
  Users as UsersIcon2,
  Building as BuildingIcon2,
  Calendar as CalendarIcon3,
  Phone as PhoneIcon,
  Mail as MailIcon,
  MapPin as MapPinIcon,
  CheckSquare as CheckSquareIcon3,
  Square as SquareIcon2,
  ArrowUpRight as ArrowUpRightIcon,
  ArrowDownRight as ArrowDownRightIcon,
  ArrowLeft as ArrowLeftIcon,
  Home as HomeIcon3,
  Wrench as WrenchIcon2,
  FileBarChart as FileBarChartIcon,
  Cog as CogIcon2,
  Settings as SettingsIcon2,
  Link as LinkIcon,
  Monitor as MonitorIcon2,
  Tablet as TabletIcon2,
  Smartphone as SmartphoneIcon2,
  Lightbulb as LightbulbIcon3,
  Cpu as CpuIcon2,
  Network as NetworkIcon2,
  Database as DatabaseIcon2,
  Layers as LayersIcon2,
  User as UserIcon,
  Languages as LanguagesIcon,
  Mic as MicIcon,
  Play as PlayIcon,
  Pause as PauseIcon,
  Square as SquareIcon3,
  RefreshCw as RefreshCwIcon,
  Copy as CopyIcon,
  Download as DownloadIcon,
  Globe as GlobeIcon2,
  Users2 as Users2Icon,
  AlertTriangle as AlertTriangleIcon,
  CheckCircle as CheckCircleIcon,
  XCircle as XCircleIcon,
  Clock as ClockIcon3,
  Target as TargetIcon3,
  Brain as BrainIcon3,
  MessageSquare as MessageSquareIcon3,
  AlertCircle as AlertCircleIcon3,
  CheckSquare as CheckSquareIcon4
} from 'lucide-react';
import DataTable from '../common/DataTable';
import ConfirmationModal from '../common/ConfirmationModal';

const AssetROIReports = () => {
  const [activeTab, setActiveTab] = useState('roi-analysis');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showGenerateModal, setShowGenerateModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  // Mock data for ROI analysis
  const [roiAnalysis, setRoiAnalysis] = useState([
    {
      id: 'ROI-001',
      assetName: 'Fleet Vehicle - Toyota Camry 2023',
      assetId: 'ASSET-001',
      assetType: 'Vehicle',
      category: 'Fleet',
      initialInvestment: '$28,000',
      currentValue: '$22,500',
      totalRevenue: '$45,000',
      totalCosts: '$18,500',
      netProfit: '$26,500',
      roi: 94.6,
      paybackPeriod: '18 months',
      status: 'Active',
      acquisitionDate: '2023-01-15',
      lastCalculated: '2024-02-15',
      createdBy: 'AI System',
      department: 'Fleet Management',
      isActive: true,
      tags: ['vehicle', 'fleet', 'high-roi'],
      isBookmarked: true,
      isStarred: false,
      viewCount: 45,
      downloadCount: 8,
      aiInsights: ['Excellent ROI performance', 'Maintenance costs optimized', 'Utilization rate high'],
      keyDrivers: ['High utilization', 'Low maintenance', 'Fuel efficiency'],
      riskFactors: ['Depreciation', 'Accident risk', 'Market value decline'],
      utilizationRate: 87.3,
      maintenanceCosts: '$2,500',
      fuelCosts: '$4,200',
      insuranceCosts: '$1,800'
    },
    {
      id: 'ROI-002',
      assetName: 'Manufacturing Equipment - CNC Machine',
      assetId: 'ASSET-002',
      assetType: 'Equipment',
      category: 'Manufacturing',
      initialInvestment: '$180,000',
      currentValue: '$145,000',
      totalRevenue: '$320,000',
      totalCosts: '$95,000',
      netProfit: '$225,000',
      roi: 125.0,
      paybackPeriod: '14 months',
      status: 'Active',
      acquisitionDate: '2022-06-01',
      lastCalculated: '2024-02-15',
      createdBy: 'AI System',
      department: 'Operations',
      isActive: true,
      tags: ['equipment', 'manufacturing', 'excellent-roi'],
      isBookmarked: false,
      isStarred: true,
      viewCount: 67,
      downloadCount: 12,
      aiInsights: ['Outstanding ROI performance', 'Production efficiency high', 'Maintenance schedule optimal'],
      keyDrivers: ['High production volume', 'Efficient operation', 'Quality output'],
      riskFactors: ['Technology obsolescence', 'Maintenance complexity', 'Market demand'],
      utilizationRate: 92.1,
      maintenanceCosts: '$8,500',
      energyCosts: '$12,000',
      operatorCosts: '$24,000'
    },
    {
      id: 'ROI-003',
      assetName: 'Office Building - Downtown Location',
      assetId: 'ASSET-003',
      assetType: 'Real Estate',
      category: 'Property',
      initialInvestment: '$3,200,000',
      currentValue: '$3,500,000',
      totalRevenue: '$480,000',
      totalCosts: '$180,000',
      netProfit: '$300,000',
      roi: 9.4,
      paybackPeriod: '128 months',
      status: 'Active',
      acquisitionDate: '2020-03-15',
      lastCalculated: '2024-02-15',
      createdBy: 'AI System',
      department: 'Real Estate',
      isActive: true,
      tags: ['real-estate', 'property', 'stable-roi'],
      isBookmarked: true,
      isStarred: false,
      viewCount: 89,
      downloadCount: 15,
      aiInsights: ['Stable long-term investment', 'Property value appreciation', 'Rental income consistent'],
      keyDrivers: ['Location value', 'Property appreciation', 'Rental income'],
      riskFactors: ['Market volatility', 'Maintenance costs', 'Interest rates'],
      utilizationRate: 95.2,
      maintenanceCosts: '$45,000',
      propertyTaxes: '$32,000',
      insuranceCosts: '$18,000'
    }
  ]);

  // Mock data for TCO tracking
  const [tcoTracking, setTcoTracking] = useState([
    {
      id: 'TCO-001',
      assetName: 'IT Infrastructure - Server Rack',
      assetId: 'ASSET-004',
      assetType: 'IT Equipment',
      category: 'Technology',
      acquisitionCost: '$85,000',
      installationCost: '$12,000',
      maintenanceCosts: '$18,500',
      energyCosts: '$24,000',
      supportCosts: '$15,000',
      totalCostOfOwnership: '$154,500',
      usefulLife: '5 years',
      annualTCO: '$30,900',
      status: 'Active',
      acquisitionDate: '2023-03-01',
      lastUpdated: '2024-02-15',
      createdBy: 'AI System',
      department: 'IT',
      isActive: true,
      tags: ['it-infrastructure', 'servers', 'tco-tracking'],
      isBookmarked: false,
      isStarred: true,
      viewCount: 34,
      downloadCount: 6,
      aiInsights: ['TCO within budget', 'Energy efficiency good', 'Maintenance costs controlled'],
      costBreakdown: {
        acquisition: 55.0,
        maintenance: 12.0,
        energy: 15.5,
        support: 9.7,
        other: 7.8
      },
      costTrend: 'Stable',
      efficiencyRating: 'Good'
    },
    {
      id: 'TCO-002',
      assetName: 'HVAC System - Building A',
      assetId: 'ASSET-005',
      assetType: 'HVAC',
      category: 'Facilities',
      acquisitionCost: '$125,000',
      installationCost: '$18,000',
      maintenanceCosts: '$28,500',
      energyCosts: '$45,000',
      supportCosts: '$8,500',
      totalCostOfOwnership: '$225,000',
      usefulLife: '15 years',
      annualTCO: '$15,000',
      status: 'Active',
      acquisitionDate: '2022-08-15',
      lastUpdated: '2024-02-10',
      createdBy: 'AI System',
      department: 'Facilities',
      isActive: true,
      tags: ['hvac', 'facilities', 'energy-efficient'],
      isBookmarked: true,
      isStarred: false,
      viewCount: 42,
      downloadCount: 7,
      aiInsights: ['Energy costs high', 'Maintenance schedule optimal', 'Efficiency improvements needed'],
      costBreakdown: {
        acquisition: 55.6,
        maintenance: 12.7,
        energy: 20.0,
        support: 3.8,
        other: 7.9
      },
      costTrend: 'Increasing',
      efficiencyRating: 'Fair'
    }
  ]);

  // Calculate statistics
  const stats = {
    totalAssets: roiAnalysis.length,
    averageROI: roiAnalysis.reduce((sum, asset) => sum + asset.roi, 0) / roiAnalysis.length,
    highROIAssets: roiAnalysis.filter(asset => asset.roi >= 50).length,
    totalInvestment: roiAnalysis.reduce((sum, asset) => {
      const investment = parseFloat(asset.initialInvestment.replace(/[$,]/g, ''));
      return sum + investment;
    }, 0),
    totalRevenue: roiAnalysis.reduce((sum, asset) => {
      const revenue = parseFloat(asset.totalRevenue.replace(/[$,]/g, ''));
      return sum + revenue;
    }, 0),
    totalTCOAssets: tcoTracking.length,
    averageTCO: tcoTracking.reduce((sum, asset) => {
      const tco = parseFloat(asset.totalCostOfOwnership.replace(/[$,]/g, ''));
      return sum + tco;
    }, 0) / tcoTracking.length,
    totalTCO: tcoTracking.reduce((sum, asset) => {
      const tco = parseFloat(asset.totalCostOfOwnership.replace(/[$,]/g, ''));
      return sum + tco;
    }, 0)
  };

  const tabs = [
    { id: 'roi-analysis', label: 'ROI Analysis' },
    { id: 'tco-tracking', label: 'TCO Tracking' },
    { id: 'utilization', label: 'Utilization Reports' },
    { id: 'benchmarks', label: 'Benchmarks' }
  ];

  // Define columns for ROI Analysis DataTable
  const roiColumns = [
    {
      key: 'assetName',
      label: 'Asset & ROI Details',
      width: '300px',
      render: (value, row) => (
        <div>
          <div style={{ fontWeight: '500', color: '#1f2937', marginBottom: '4px' }}>{value}</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>
            {row.assetType} • {row.category} • {row.assetId}
          </div>
        </div>
      )
    },
    {
      key: 'initialInvestment',
      label: 'Initial Investment',
      width: '140px',
      render: (investment) => (
        <span style={{ fontWeight: '600', color: '#1f2937' }}>{investment}</span>
      )
    },
    {
      key: 'netProfit',
      label: 'Net Profit',
      width: '120px',
      render: (profit) => (
        <span style={{ fontWeight: '600', color: '#10b981' }}>{profit}</span>
      )
    },
    {
      key: 'roi',
      label: 'ROI',
      width: '100px',
      render: (roi) => (
        <span style={{ 
          fontWeight: '600', 
          color: roi >= 50 ? '#10b981' : roi >= 20 ? '#f59e0b' : '#ef4444' 
        }}>
          {roi.toFixed(1)}%
        </span>
      )
    },
    {
      key: 'paybackPeriod',
      label: 'Payback Period',
      width: '120px',
      render: (period) => (
        <span style={{ fontSize: '12px', color: '#6b7280' }}>{period}</span>
      )
    },
    {
      key: 'utilizationRate',
      label: 'Utilization',
      width: '120px',
      render: (rate) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div style={{
            width: '60px',
            height: '6px',
            backgroundColor: '#e5e7eb',
            borderRadius: '3px',
            overflow: 'hidden'
          }}>
            <div style={{
              width: `${rate}%`,
              height: '100%',
              backgroundColor: rate >= 80 ? '#10b981' : rate >= 60 ? '#f59e0b' : '#ef4444',
              transition: 'width 0.3s ease'
            }} />
          </div>
          <span style={{ 
            fontSize: '12px', 
            fontWeight: '500', 
            color: rate >= 80 ? '#10b981' : rate >= 60 ? '#f59e0b' : '#ef4444' 
          }}>
            {rate}%
          </span>
        </div>
      )
    },
    {
      key: 'status',
      label: 'Status',
      width: '100px',
      render: (status) => {
        const statusConfig = {
          'Active': { color: '#10b981', bg: '#d1fae5', icon: <CheckCircle size={14} /> },
          'Inactive': { color: '#6b7280', bg: '#f3f4f6', icon: <XCircle size={14} /> },
          'Maintenance': { color: '#f59e0b', bg: '#fef3c7', icon: <Wrench size={14} /> }
        };
        const config = statusConfig[status] || statusConfig['Active'];
        
        return (
          <span style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '6px 10px',
            borderRadius: '6px',
            fontSize: '12px',
            fontWeight: '500',
            backgroundColor: config.bg,
            color: config.color,
            width: 'fit-content'
          }}>
            {config.icon}
            {status}
          </span>
        );
      }
    },
    {
      key: 'actions',
      label: 'Actions',
      width: '200px',
      render: (value, row) => (
        <div style={{ display: 'flex', gap: '6px' }}>
          <button
            onClick={() => handleView(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#007B8F',
              color: '#007B8F',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="View Details"
          >
            <Eye size={14} /> View
          </button>
          <button
            onClick={() => handleExport(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#10b981',
              color: '#10b981',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Export Report"
          >
            <Download size={14} /> Export
          </button>
          <button
            onClick={() => handleDelete(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#ef4444',
              color: '#ef4444',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Delete Analysis"
          >
            <Trash2 size={14} /> Delete
          </button>
        </div>
      )
    }
  ];

  // Define columns for TCO Tracking DataTable
  const tcoColumns = [
    {
      key: 'assetName',
      label: 'Asset & TCO Details',
      width: '300px',
      render: (value, row) => (
        <div>
          <div style={{ fontWeight: '500', color: '#1f2937', marginBottom: '4px' }}>{value}</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>
            {row.assetType} • {row.category} • {row.assetId}
          </div>
        </div>
      )
    },
    {
      key: 'totalCostOfOwnership',
      label: 'Total TCO',
      width: '120px',
      render: (tco) => (
        <span style={{ fontWeight: '600', color: '#1f2937' }}>{tco}</span>
      )
    },
    {
      key: 'annualTCO',
      label: 'Annual TCO',
      width: '120px',
      render: (annual) => (
        <span style={{ fontWeight: '500', color: '#6b7280' }}>{annual}</span>
      )
    },
    {
      key: 'usefulLife',
      label: 'Useful Life',
      width: '100px',
      render: (life) => (
        <span style={{ fontSize: '12px', color: '#6b7280' }}>{life}</span>
      )
    },
    {
      key: 'costTrend',
      label: 'Cost Trend',
      width: '100px',
      render: (trend) => {
        const trendConfig = {
          'Decreasing': { color: '#10b981', bg: '#d1fae5', icon: <TrendingDown size={14} /> },
          'Stable': { color: '#6b7280', bg: '#f3f4f6', icon: <Minus size={14} /> },
          'Increasing': { color: '#ef4444', bg: '#fee2e2', icon: <TrendingUp size={14} /> }
        };
        const config = trendConfig[trend] || trendConfig['Stable'];
        
        return (
          <span style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '6px 10px',
            borderRadius: '6px',
            fontSize: '12px',
            fontWeight: '500',
            backgroundColor: config.bg,
            color: config.color,
            width: 'fit-content'
          }}>
            {config.icon}
            {trend}
          </span>
        );
      }
    },
    {
      key: 'efficiencyRating',
      label: 'Efficiency',
      width: '100px',
      render: (rating) => {
        const ratingConfig = {
          'Excellent': { color: '#10b981', bg: '#d1fae5' },
          'Good': { color: '#3b82f6', bg: '#dbeafe' },
          'Fair': { color: '#f59e0b', bg: '#fef3c7' },
          'Poor': { color: '#ef4444', bg: '#fee2e2' }
        };
        const config = ratingConfig[rating] || ratingConfig['Fair'];
        
        return (
          <span style={{
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: '500',
            backgroundColor: config.bg,
            color: config.color
          }}>
            {rating}
          </span>
        );
      }
    },
    {
      key: 'status',
      label: 'Status',
      width: '100px',
      render: (status) => {
        const statusConfig = {
          'Active': { color: '#10b981', bg: '#d1fae5', icon: <CheckCircle size={14} /> },
          'Inactive': { color: '#6b7280', bg: '#f3f4f6', icon: <XCircle size={14} /> },
          'Maintenance': { color: '#f59e0b', bg: '#fef3c7', icon: <Wrench size={14} /> }
        };
        const config = statusConfig[status] || statusConfig['Active'];
        
        return (
          <span style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '6px 10px',
            borderRadius: '6px',
            fontSize: '12px',
            fontWeight: '500',
            backgroundColor: config.bg,
            color: config.color,
            width: 'fit-content'
          }}>
            {config.icon}
            {status}
          </span>
        );
      }
    },
    {
      key: 'actions',
      label: 'Actions',
      width: '200px',
      render: (value, row) => (
        <div style={{ display: 'flex', gap: '6px' }}>
          <button
            onClick={() => handleView(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#007B8F',
              color: '#007B8F',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="View Details"
          >
            <Eye size={14} /> View
          </button>
          <button
            onClick={() => handleExport(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#10b981',
              color: '#10b981',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Export Report"
          >
            <Download size={14} /> Export
          </button>
          <button
            onClick={() => handleDelete(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#ef4444',
              color: '#ef4444',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Delete Tracking"
          >
            <Trash2 size={14} /> Delete
          </button>
        </div>
      )
    }
  ];

  // Handler functions
  const handleView = (item) => {
    //console.log('Viewing item:', item.assetName);
  };

  const handleExport = (asset) => {
    setSelectedItem(asset);
    setShowExportModal(true);
  };

  const handleDelete = (item) => {
    setSelectedItem(item);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    setIsDeleting(true);
    try {
      if (activeTab === 'roi-analysis') {
        setRoiAnalysis(prev => prev.filter(asset => asset.id !== selectedItem.id));
      } else {
        setTcoTracking(prev => prev.filter(asset => asset.id !== selectedItem.id));
      }
      setShowDeleteModal(false);
      setSelectedItem(null);
    } catch (error) {
      console.error('Error deleting item:', error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleExportConfirm = async () => {
    setIsProcessing(true);
    try {
      setShowExportModal(false);
      setSelectedItem(null);
      // Here you would typically export the report
    } catch (error) {
      console.error('Error exporting report:', error);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div style={{
      padding: '24px',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
      backgroundColor: '#f8fafc',
      minHeight: '100vh'
    }}>
      {/* Header */}
      <div style={{ marginBottom: '32px' }}>
        <h1 style={{
          fontSize: '32px',
          fontWeight: '700',
          color: '#1f2937',
          margin: '0 0 8px 0',
          background: 'linear-gradient(135deg, #007B8F 0%, #4A9BA8 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}>
          Asset ROI Reports
        </h1>
        <p style={{
          fontSize: '16px',
          color: '#6b7280',
          margin: 0
        }}>
          Comprehensive ROI analysis, TCO tracking, and utilization reports for asset performance optimization
        </p>
      </div>

      {/* Tabbed Navigation */}
      <div style={{ marginBottom: '32px' }}>
        <div style={{
          display: 'flex',
          borderBottom: '1px solid #e5e7eb',
          gap: '0'
        }}>
          {tabs.map(tab => (
            <button
              key={tab.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '12px 24px',
                color: activeTab === tab.id ? '#007B8F' : '#6b7280',
                borderBottom: activeTab === tab.id ? '3px solid #007B8F' : '3px solid transparent',
                transition: 'all 0.15s ease-in-out',
                fontWeight: '500',
                fontSize: '14px',
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                borderRadius: '6px 6px 0 0',
                fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
                position: 'relative',
                marginBottom: '-1px'
              }}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.id === 'roi-analysis' && <Target size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.id === 'tco-tracking' && <Calculator size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.id === 'utilization' && <Activity size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.id === 'benchmarks' && <BarChart3 size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Stats Cards */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '24px',
        marginBottom: '32px'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Total Assets</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>{stats.totalAssets}</h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              {stats.highROIAssets} high ROI assets
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#007B8F20',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#007B8F'
          }}>
            <Package size={20} />
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Average ROI</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>
              {stats.averageROI.toFixed(1)}%
            </h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              Portfolio performance
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#10b98120',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#10b981'
          }}>
            <TrendingUp size={20} />
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Total Investment</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>
              ${(stats.totalInvestment / 1000).toFixed(0)}K
            </h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              Asset portfolio value
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#f59e0b20',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#f59e0b'
          }}>
            <DollarSign size={20} />
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Total Revenue</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>
              ${(stats.totalRevenue / 1000).toFixed(0)}K
            </h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              Generated from assets
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#8b5cf620',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#8b5cf6'
          }}>
            <Receipt size={20} />
          </div>
        </div>
      </div>

      {/* ROI Analysis Tab */}
      {activeTab === 'roi-analysis' && (
        <div>
          {/* ROI Analysis DataTable */}
          <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
            <DataTable
              data={roiAnalysis}
              columns={roiColumns}
              title={`ROI Analysis (${roiAnalysis.length} assets)`}
              searchable={false}
              sortable={true}
              exportable={true}
              pagination={true}
              pageSize={10}
              hiddenColumns={['none']}
              onHiddenColumnsChange={() => {}}
            />
          </div>
        </div>
      )}

      {/* TCO Tracking Tab */}
      {activeTab === 'tco-tracking' && (
        <div>
          {/* TCO Tracking DataTable */}
          <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
            <DataTable
              data={tcoTracking}
              columns={tcoColumns}
              title={`TCO Tracking (${tcoTracking.length} assets)`}
              searchable={false}
              sortable={true}
              exportable={true}
              pagination={true}
              pageSize={10}
              hiddenColumns={['none']}
              onHiddenColumnsChange={() => {}}
            />
          </div>
        </div>
      )}

      {/* Other Tabs */}
      {activeTab === 'utilization' && (
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
          border: '1px solid #e5e7eb',
          minHeight: '300px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '18px',
          color: '#6b7280'
        }}>
          Utilization Reports Dashboard Coming Soon!
        </div>
      )}

      {activeTab === 'benchmarks' && (
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
          border: '1px solid #e5e7eb',
          minHeight: '300px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '18px',
          color: '#6b7280'
        }}>
          Industry Benchmarks Coming Soon!
        </div>
      )}

      {/* Delete Confirmation Modal */}
      <ConfirmationModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleDeleteConfirm}
        title="Delete Asset Analysis"
        message={`Are you sure you want to delete "${selectedItem?.assetName}"? This action cannot be undone.`}
        confirmText="Delete"
        cancelText="Cancel"
        type="danger"
        isLoading={isDeleting}
      />

      {/* Export Report Modal */}
      <ConfirmationModal
        isOpen={showExportModal}
        onClose={() => setShowExportModal(false)}
        onConfirm={handleExportConfirm}
        title="Export Report"
        message={`Export ROI/TCO report for "${selectedItem?.assetName}"? This will generate a comprehensive report with analysis and insights.`}
        confirmText="Export"
        cancelText="Cancel"
        type="success"
        isLoading={isProcessing}
      />
    </div>
  );
};

export default AssetROIReports;
